export default __webpack_public_path__ + "static/15-2e783d1f473c3bfafb58b06c059924bd.png";